<app-popup [title]="event?.data?.EventTitle"
  [isBusy]="isBusy"
  [popupVisible]="isPopupVisible"
  [canSave]="true"
  [canDelete]="true"
  [canComplete]="true"
  [width]="1300"
  [height]="905"
  [fullScreen]="false"
  (completeClicked)="completeEvent()"
  (saveClicked)="saveEvent()"
  (deleteClicked)="deleteEvent()"
  (closeClicked)="closeClicked.emit(event)">

  <div *ngIf="event">
    <div class="info section">
      <div>
        <small class="small">{{languageService.LNG('Label.OrderNumber')}}</small>
        <div class="text">{{event.data.OrderNumber || "-"}}</div>
      </div>
      <div>
        <small class="small">{{languageService.LNG('Label.Assignment')}}</small>
        <div class="text">{{event.data.AssignmentName || "-"}}</div>
      </div>
      <div>
        <small class="small">{{languageService.LNG('Label.Project')}}</small>
        <div class="text">{{event.data.ProjectNumber || "-"}}, {{event.data.ProjectName || "-"}}</div>
      </div>
      <div>
        <small class="small">{{languageService.LNG('Label.Module.Id_39')}}</small>
        <div class="text">{{event.data.Article}}</div>
      </div>
      <div class="number-column">
        <small class="small">{{languageService.LNG('Label.Number')}}</small>
        <div class="text">{{event.data.Volume_str || "-"}}</div>
      </div>
    </div>

    <div class="grid-wrapper">
      <app-elevation-section [title]="event.data.ResourceName">
        <div class="resource-time">{{event.data.ProcessingTime_str}} ({{event.data.StartupTime_str}})</div>
        <div class="planned-period">
          <small class="small">{{languageService.LNG('Label.Planned')}}</small>
          <dx-date-box width="200" [(value)]="event.startDate" type="datetime" [showAnalogClock]="false" [showClearButton]="true" dateSerializationFormat="yyyy-MM-ddTHH:mm:ss" displayFormat="dd.MM.yyyy - HH:mm"></dx-date-box>
          <span class="separator">-</span>
          <dx-date-box width="200" [(value)]="event.endDate" type="datetime" [showAnalogClock]="false" [showClearButton]="true" dateSerializationFormat="yyyy-MM-ddTHH:mm:ss" displayFormat="dd.MM.yyyy - HH:mm"></dx-date-box>
        </div>

        <div class="margin-top-medium"></div>
        <small class="small">{{languageService.LNG('Label.Locked')}}</small>
        <dx-switch [(value)]="event.locked"></dx-switch>

        <div class="margin-top"></div>
        <dx-button [text]="splitButtonLabel" [disabled]="!resourcesWithinWorkgroup" (onClick)="isSplitJobPopupVisible = true"></dx-button>
      </app-elevation-section>

      <div *ngIf="!isEmployee">
        <app-elevation-section [title]="languageService.LNG('Label.Resource.Load')">
          <dx-data-grid class="space-between-grid-and-actions"
            [height]="200"
            rowAlternationEnabled="true"
            hoverStateEnabled="true"
            [showBorders]="true"
            [columnAutoWidth]="true"
            [dataSource]="connectedEvents"
            [columns]="[
              { dataField: 'data.ResourceId', caption: languageService.LNG('Label.Resource'), width: '35%', lookup: { dataSource: resources, valueExpr: 'ResourceId', displayExpr: 'Name' }, validationRules: [{ type: 'required' }], editCellTemplate: 'employeeEditCellTemplate' },
              { dataField: 'startDate', caption: languageService.LNG('Label.From'), dataType: 'datetime', serializationFormat: 'yyyy-MM-dd HH:mm', format: 'dd.MM.yyyy - HH:mm', editorOptions: { showAnalogClock: false }, validationRules: [{ type: 'required' }], sortOrder: 'asc' },
              { dataField: 'endDate', caption: languageService.LNG('Label.To'), dataType: 'datetime', serializationFormat: 'yyyy-MM-dd HH:mm', format: 'dd.MM.yyyy - HH:mm', editorOptions: { showAnalogClock: false }, validationRules: [{ type: 'required' }] },
              { dataField: 'data.WorkRate', caption: languageService.LNG('Label.Rate'), dataType: 'number', width: 60, visible: false }
            ]"

            (onRowInserting)="addConnectedJob($event)"
            (onRowUpdating)="updateConnectedJob($event)"
            (onRowRemoving)="removeConnectedJob($event)">

            <dxo-editing mode="row" useIcons="true"
              [allowUpdating]="true"
              [allowDeleting]="true"
              [allowAdding]="true">
            </dxo-editing>

            <div *dxTemplate="let cellInfo of 'employeeEditCellTemplate'">
              <dx-drop-down-box
                [dropDownOptions]="{ width: 500 }"
                [dataSource]="resources"
                [(value)]="cellInfo.value"
                displayExpr="Name"
                valueExpr="ResourceId"
                contentTemplate="contentTemplate">

                <div *dxTemplate="let e of 'contentTemplate'">
                  <dx-data-grid
                    keyExpr="ResourceId"
                    rowAlternationEnabled="true"
                    hoverStateEnabled="true"
                    [showBorders]="true"
                    [dataSource]="connectableResources"
                    [height]="250"
                    [selectedRowKeys]="[cellInfo.value]"
                    [focusedRowEnabled]="true"
                    [focusedRowKey]="cellInfo.value"
                    [hoverStateEnabled]="true"
                    (onSelectionChanged)="onEmployeeResourceSelectionChanged($event.selectedRowKeys, cellInfo, e.component)">

                    <dxi-column dataField="ResourceName" [caption]="languageService.LNG('Label.Name')"></dxi-column>
                    <dxi-column dataField="ReservedTimeFormatted" [caption]="languageService.LNG('Label.ActualUse')" alignment="right" width="110"></dxi-column>
                    <dxi-column dataField="CompetenceValue" [caption]="languageService.LNG('Label.Competency')" dataType="number" sortOrder="desc" width="130"></dxi-column>
                    <dxo-scrolling mode="virtual"></dxo-scrolling>
                    <dxo-selection mode="single"></dxo-selection>
                  </dx-data-grid>
                </div>
              </dx-drop-down-box>
            </div>

          </dx-data-grid>
        </app-elevation-section>
      </div>
    </div>

    <app-load-indicator *ngIf="isLoadingDependencies"></app-load-indicator>
    <app-gantt *ngIf="!isLoadingDependencies"
      [height]="400"
      [tasks]="tasks"
      [columns]="[
        { dataField: 'title', caption: languageService.LNG('Label.Operation'), width: 250 },
        { dataField: 'start', caption: languageService.LNG('Label.Start'), dataType: 'datetime', format: 'dd.MM.yyyy HH:mm' },
        { dataField: 'end', caption: languageService.LNG('Label.End'), dataType: 'datetime', format: 'dd.MM.yyyy HH:mm' }
      ]"
      [selectedRowKey]="event?.data.OperationResourceId">
    </app-gantt>

  </div>
</app-popup>

<app-popup *ngIf="resourcesWithinWorkgroup && isSplitJobPopupVisible" [title]="languageService.LNG('Label.Resources')"
  [isBusy]="isBusy"
  width="500"
  height="750"
  [canSave]="true"
  [saveEnabled]="resourceIdsToSplitJobBetween.length !== 0"
  [popupVisible]="isSplitJobPopupVisible"
  (saveClicked)="splitJobsBetweenResources()"
  (closeClicked)="isSplitJobPopupVisible = false">
  <div class="selected-columns-wrapper">
    <app-data-grid class="selected-columns"
      selectionMode="multiple"
      [showColumnHeaders]="false"
      [hasSearch]="false"
      [dataSource]="resourcesWithinWorkgroup"
      keyExpr="ResourceId"
      [columns]="[{ dataField: 'Name' }]"
      (selectionChanged)="onSplitJobResourceSelectionChanged($event)">
    </app-data-grid>
  </div>
</app-popup>
